import type { WeatherStation } from './types';

/** Une année simulée : DJU (chauffage) et DJClim (froid), jamais des relevés. */
export interface DegreeYear {
  /** Année civile, ou null pour la ligne « Année simulée ». */
  year: number | null;
  label: string;
  dju: number;
  djclim: number;
}

export const HISTORY_FROM = 2018;
export const HISTORY_TO = 2025;

/** Écarts annuels de démonstration appliqués aux hypothèses fixes (en %). */
const HEAT_DRIFT: Record<number, number> = {
  2018: -0.04, 2019: -0.02, 2020: -0.07, 2021: 0.03, 2022: -0.09, 2023: -0.05, 2024: -0.01, 2025: -0.06,
};
const COOL_DRIFT: Record<number, number> = {
  2018: 0.08, 2019: 0.14, 2020: 0.11, 2021: -0.12, 2022: 0.28, 2023: 0.17, 2024: 0.05, 2025: 0.21,
};

/**
 * Historique simulé de 2018 à 2025, plus la ligne « Année simulée ».
 * Dérivé d'hypothèses communes par un écart fixe par année, sans normale source.
 */
export function stationHistory(s: WeatherStation): DegreeYear[] {
  const years: DegreeYear[] = [];
  for (let y = HISTORY_FROM; y <= HISTORY_TO; y += 1) {
    years.push({
      year: y,
      label: `${y} (simulé)`,
      dju: Math.round(s.dju * (1 + (HEAT_DRIFT[y] ?? 0))),
      djclim: Math.round(s.djclim * (1 + (COOL_DRIFT[y] ?? 0))),
    });
  }
  years.push({ year: null, label: 'Année simulée', dju: s.dju, djclim: s.djclim });
  return years;
}
